module.exports = __webpack_public_path__ + "img/global.4731d8e9.svg";